// src/index.tsx
import '@ant-design/v5-patch-for-react-19';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App as AntdApp } from 'antd';
import App from './App';
import './index.css';
import AppThemeProvider from "./theme/AppThemeProvider";

const container = document.getElementById('root');
if (!container) throw new Error('Root element #root not found');

createRoot(container).render(
  <StrictMode>
    <AntdApp>
      <AppThemeProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </AppThemeProvider>
    </AntdApp>
  </StrictMode>
);

// PWA: регистрируем service worker (только в production — на проде HTTPS).
// Нужен для установки админки как приложения на телефон (иконка, полный экран).
if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register(`${process.env.PUBLIC_URL}/service-worker.js`)
      .catch(() => { /* установка PWA необязательна для работы */ });
  });
}
